import { getLowestPersonalizedPayment, getPersonalizedPaymentByLender } from '@atc/wallet-payment-fns';
import { getCashOffer, getLeaseOffer } from 'reaxl-wallet';

// --- Payment Functions ---
const getPaymentsOfferObj = function () {
  let paymentDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let udsLocalStateValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    selectedLeaseTerm,
    selectedLoanTerm,
    financeOffersObj,
    obfuscatedCredit
  } = udsLocalStateValues;
  const financeOffers = !financeOffersObj?.lendingOptionSelected ? getLowestPersonalizedPayment(paymentDetails, obfuscatedCredit, selectedLoanTerm) : getPersonalizedPaymentByLender(paymentDetails, obfuscatedCredit, selectedLoanTerm, financeOffersObj?.lender);
  return {
    financeOfferValues: financeOffers,
    leaseOfferValues: getLeaseOffer(paymentDetails, obfuscatedCredit, selectedLeaseTerm),
    cashOfferValues: getCashOffer(paymentDetails, obfuscatedCredit)
  };
};
export { getPaymentsOfferObj as default };
